import PropTypes from 'prop-types';
import styled from 'styled-components';
import { INPUT_SIZES } from '../../constants';
import { InputMixin } from '../../mixins/components/InputMixin';
import { FormControl } from '../FormControl/FormControl';

/**
 * @since 1.3.0
 */
var Input = /*#__PURE__*/styled(FormControl).withConfig({
  displayName: "Input",
  componentId: "c11n-8-107-0__sc-4ry0fw-0"
})(["", ""], InputMixin);
Input.displayName = 'Input';
Input.propTypes = {
  /**
   * Used for
   * [autofill](https://developers.google.com/web/updates/2015/06/checkout-faster-with-autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * Determines the size of the input.
   */
  size: PropTypes.oneOf(Object.values(INPUT_SIZES)),
  /**
   * Displays the input in an error state. Can also be inherited from a FormField parent.
   */
  error: PropTypes.bool,
  /**
   * The HTML input type.
   * @ignore
   */
  type: PropTypes.string,
  /**
   * Inputs are fluid by default which means they stretch to fill the entire width of their
   * container. When `fluid="false"`, the inputs's width is set to `auto`.
   */
  fluid: PropTypes.bool,
  /**
   * Indicates the input is required. Can also be inherited from a FormField parent.
   */
  required: PropTypes.bool,
  /**
   * Displays the input in a disabled state. Can also be inherited from a FormField parent.
   */
  disabled: PropTypes.bool,
  /**
   * Displays the input in a read-only state. Can also be inherited from a FormField parent.
   *
   * @since 8.27.0
   */
  readOnly: PropTypes.bool
};
Input.defaultProps = {
  size: INPUT_SIZES.md,
  type: 'text',
  fluid: true
};

/** @component */
export { Input };